"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nl2br = exports.formatNumber = exports.formatMoney = exports.formatDateTime = exports.formatDate = void 0;
const moment_1 = __importDefault(require("moment"));
const currency_js_1 = __importDefault(require("currency.js"));
const formatDate = (value) => {
    return (0, moment_1.default)(value).format('DD/MM/YYYY');
};
exports.formatDate = formatDate;
const formatDateTime = (value) => {
    return (0, moment_1.default)(value).format('DD/MM/YYYY HH:mm:ss');
};
exports.formatDateTime = formatDateTime;
const formatMoney = (value, options) => {
    return (0, currency_js_1.default)(value).format({
        symbol: (options === null || options === void 0 ? void 0 : options.symbol) || 'R$ ',
        decimal: (options === null || options === void 0 ? void 0 : options.decimal) || ',',
        separator: (options === null || options === void 0 ? void 0 : options.separator) || '.'
    });
};
exports.formatMoney = formatMoney;
const formatNumber = (value) => {
    return Number(value).toLocaleString('pt-BR');
};
exports.formatNumber = formatNumber;
const nl2br = (text) => text.replace(/\n/g, "<br />");
exports.nl2br = nl2br;
